import { PARKED } from 'components/orders/constants'

export default function shouldSyncOrder(order) {
  return order.orderType !== PARKED
}
